export default "__VITE_ASSET__Dz60qAMM__"